// @TODO: This logic is copied from "getPmsInterface" in the serverless codebase.
// Update this if Chirp eventually supports other PMS integrations.
export function isUnitFromPmsIntegration(sourceId: string | null | undefined) {
  return Boolean(sourceId && sourceId.startsWith('RP-'));
}

export function isUnitFromStratis(sourceId: string | null | undefined) {
  return Boolean(sourceId && sourceId.startsWith('un-'));
}
